import React from 'react'
import Query from './Query'
import ContentNavigation from '../ContentNavigation'

export default () => (
  <Query
    render={(content) => (
      <ContentNavigation
        items={[
          {
            label: content.content_navigation.about,
            href: '/education/'
          },
          {
            label: content.content_navigation.educators,
            href: '/education/educators/'
          },
          {
            label: content.content_navigation.courses,
            href: '/education/courses/'
          }
        ]}
      />
    )}
  />
)
